/**
 * uuid isn't support in react native, this provides a random string genrator.
 *
 * NOTE - this is not a valid guid.
 */
export const generateRandomID = (length = 10) => {
    const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let id = '';
    for (let i = 0; i < length; i++) {
        id += chars[Math.floor(Math.random() * chars.length)];
    }
    return id;
};
